const basemapStateSelector = (state: any) => state.basemap

const mapStyleSelector = (state: any) => state.basemap?.mapStyle

export { basemapStateSelector, mapStyleSelector }
